import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import Controls from '../Carousel/Controls/Controls';
import MotionTrack from '../Carousel/MotionTrack/MotionTrack';
import FullWidthCarouselStyles from '../FullWidthCarousel/FullWidthCarousel.styles';
const Container = styled(SectionWrapper) ``;
const MainImageWrapper = styled.div `
  position: relative;
`;
const MainImage = styled.img `
  /* width: 880px; // dev only
  height: 500px; // dev only */
  cursor: pointer;
`;
const ImageCaption = styled.span `
  margin-top: ${fluid(10, 16)};
  font-size: 14px;
`;
const CopyrightInformation = styled.div `
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 4px 9px;
  background-color: ${brand.white};
  ${fonts.agBook.light};
  font-style: italic;
  font-size: 12px;
  line-height: 14px;
  z-index: 1;

  &[data-copyright-info-position='left'] {
    right: auto;
    left: 0;
  }
`;
const GalleryNavWrapper = styled.div `
  position: relative;
  margin-top: ${fluid(10, 16)};
`;
const GalleryNav = styled.div `
  position: static;
  --itemGutter: ${fluid(10, 16)};
  --visibleItems: 2;
  width: calc(100% - calc(var(--itemGutter) * 7));
  margin-left: auto;
  margin-right: auto;
  overflow-x: hidden;

  @media ${from(Device.TabletSmall)} {
    --visibleItems: 4;
  }
`;
const Track = styled(MotionTrack) ``;
const Item = styled(FullWidthCarouselStyles.Item) `
  &:last-child {
    padding-right: 0;
  }
`;
const Thumbnail = styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const StyledControls = styled(Controls) `
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  justify-content: space-between;

  * {
    pointer-events: auto;
  }
`;
const Button = styled(FullWidthCarouselStyles.Button) `
  padding: 0;

  &:first-child {
    justify-content: flex-start;
    margin-left: -8px;
  }

  &:last-child {
    justify-content: flex-end;
    margin-right: -8px;
  }
`;
export const ImageGalleryStyles = {
    Button,
    Container,
    Controls: StyledControls,
    CopyrightInformation,
    GalleryNav,
    GalleryNavWrapper,
    ImageCaption,
    Item,
    MainImage,
    MainImageWrapper,
    Thumbnail,
    Track,
};
